import React, {useState} from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import stateMap from "store/stateMap";
import fancybox from "component/Fancybox/Fancybox";
import { popinfo } from "component/Fancybox/Fancybox";
import { useFormik } from 'formik';
import api from "api";

import {QuillBuilder} from "../../component/RichEditor/RichEditor"
import _ from "lodash";
import { useRef } from "react";

const ComponentConfigAboutForm = connect(stateMap) (props => {
    
    const [biographyWYSIWYG, setBiographyWYSIWYG] = useState(false);
    const biographyElement          = useRef(null);

    const formik = useFormik({
        initialValues: {
            UserAbout    : props.profile.UserAbout
        }
        ,onSubmit : (values) => {
            let savingAbout = popinfo('loading', 'Updating About', 'Thank your for completing your information')

            api('/Config/About', 'post', _.assignIn({}, values, {
                UserAbout : biographyWYSIWYG.root.innerHTML
            }) , 'Bearer ' + props.auth.token)
                .then(function(response){

                    savingAbout.close();

                    if(props.onChanged)
                    {
                        props.onChanged.apply(null, [biographyWYSIWYG.root.innerHTML]);
                    }

                })
                .catch(error => {
                    popinfo('error', 'Updating About', error, {}, savingAbout)
                })
        }
    });

    useEffect(() => {


        if(!biographyElement.current)
        {
            return;
        }

        var rte = QuillBuilder(biographyElement.current);

        rte.once('editor-change', () => {
            setBiographyWYSIWYG(rte);
        });

        rte.setText('\n', 'silent');

        rte.setContents(rte.clipboard.convert(props.profile.UserAbout), 'silent');

        // rte.clipboard.dangerouslyPasteHTML(props.profile.UserAbout, 'silent');

        rte.focus();

    }, []);

    return (
        <form className="generic-form" onSubmit={formik.handleSubmit}>
            <div className="form-group">
                <div className="text-sm mt-sm mb-sm leading-text light">Give a few sentences that can describe yourself well. A complete biography will make it easier for you to be accepted in an initiative</div>
                <hr />
                <div ref={biographyElement}></div>
            </div>
            <div className="form-group text-right">
                <input type="submit" className="btn btn-primary btn-small" value="Update" />
            </div>
        </form>
    )
})

const ComponentConfigAbout = connect(stateMap) (props => {   
    const [profile, setProfile] = useState(null);

    useEffect(() => {

        setProfile(props.profile);

    }, [props.profile])
    
    const openDialog = () => {
        if(!profile)
        {
            return;
        }

        const AboutPop = fancybox(
            <div className="w-640">
                <ComponentConfigAboutForm profile={profile} onChanged={(About) => {
                    AboutPop.close();

                    if(props.onChanged)
                    {
                        props.onChanged.apply(null, [About]);
                    }

                }}/>
            </div>
        )
    }

    return (
        profile && <button onClick={openDialog} className="btn btn-small btn-orange">Update About</button>
    )
});

export { ComponentConfigAbout }